import {
  ECommercialOwnershipVerificationFormViewFields,
  TCommercialOwnershipVerificationFormViewState,
} from '../../components/CommercialOwnershipWidget/components/CommercialOwnershipVerificationForm';
import { IAppState } from '../../redux';

import { selectHomeowner } from './selectHomeowner';

export const selectFormattedHomeowner = (
  state: IAppState,
): Partial<TCommercialOwnershipVerificationFormViewState> | undefined => {
  const homeOwner = selectHomeowner(state);

  if (!homeOwner) {
    return undefined;
  }

  return {
    [ECommercialOwnershipVerificationFormViewFields.CadastralNumber]: {
      value: homeOwner.cadastralNumber ?? '',
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]: {
      value: homeOwner.identificationPersonType ?? undefined,
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.Inn]: {
      value: homeOwner.inn ?? '',
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.LastName]: {
      value: homeOwner.lastName ?? '',
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.FirstName]: {
      value: homeOwner.firstName ?? '',
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.SecondName]: {
      value: homeOwner.secondName ?? '',
      errorMessage: '',
    },
    [ECommercialOwnershipVerificationFormViewFields.CompanyName]: {
      value: homeOwner.companyName ?? undefined,
      errorMessage: '',
    },
  };
};
